import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { SurveyContainer, SurveyDetails, SurveyQuestion, ChatbaseSurvey } from './components';
import { CampaignType, FeedbackStatus } from 'Types/Enums';
import { setSection, setUserCoords } from 'store/slices';
import { useGeolocation } from 'Hooks/useGeolocation';
import { useIsNewSurvey } from 'Utils/surveyUtils';

export const NewSurvey = () => {
	const {
		activeSurvey: { currentQuestion: currentQuestionIndex, survey, status },
		hasStartedSurvey,
		section,
	} = useAppSelector((state) => state.survey);

	const dispatch = useAppDispatch();	
	const coords = useGeolocation(true);

	const currentQuestion = survey?.questions[currentQuestionIndex];
	const isChatbaseSurvey = !!survey?.chatbaseAgentId;
	const isNewSurvey = useIsNewSurvey();

	useEffect(() => {
		if (survey?.campaignType === CampaignType.brandLoopOnly && section === 'questions') {
			dispatch(setSection('brandSharingSettings'));
		}
	}, [section, survey?.campaignType]);

	// Auto-navigate to brand permissions when chatbase survey is completed
	useEffect(() => {
		if (isChatbaseSurvey && status === FeedbackStatus.ChatbaseCompleted && section === 'questions') {
			dispatch(setSection('brandSharingSettings'));
		}
	}, [isChatbaseSurvey, status, section, dispatch]);

	useEffect(() => {
		if (coords) {
			dispatch(setUserCoords(coords));
		}
	}, [coords, dispatch]);

	// Determine which component to render
	const renderContent = () => {
		// If survey is missing, render nothing (route guard will redirect below)
		if (!survey) return null;
		// Show start screen for new surveys (not started yet)
		if (isNewSurvey && !hasStartedSurvey && survey?.campaignType !== CampaignType.brandLoopOnly) {
			return <SurveyDetails />;
		}

		// Show chatbase widget for chatbase surveys in questions section
		if (isChatbaseSurvey && section === 'questions') {
			return <ChatbaseSurvey onComplete={() => dispatch(setSection('brandSharingSettings'))} />;
		}

		// Default: show regular question component
		return <SurveyQuestion question={currentQuestion} />;
	};

	// Redirect away if there is no active survey (e.g., after closing)
	if (!survey) {
		return null;
	}

	return (
		<SurveyContainer>
			{renderContent()}
		</SurveyContainer>
	);
};
